import { useGetCreatorBenchmarks } from './api/useGetCreatorBenchmarks';
import { useGetCreatorInsights } from './api/useGetCreatorInsights';

/**
 * @deprecated use useGetCreatorBenchmarks and useGetCreatorInsights instead.
 */
export const useInsightsAndBenchmarks = () => {
  const getInsights = useGetCreatorInsights();
  const getBenchmarks = useGetCreatorBenchmarks();

  const fetchInsightsAndBenchmarks = async ({
    creatorIds,
    managerId,
  }: {
    creatorIds: string[];
    managerId: string;
  }) => {
    const [{ data: insights }, { data: benchmarks }] = await Promise.all([
      getInsights.mutateAsync({ managerId, creatorIds }),
      getBenchmarks.mutateAsync({ managerId, creatorIds }),
    ]);
    return {
      insights,
      benchmarks,
    };
  };

  return {
    fetchInsightsAndBenchmarks,
  };
};
